export default {
  common: {
    loginTitle: '登錄',
    createPasswordTitle: '創建你的密碼',
    forgetPasswordTitle: '忘記密碼',
    resetPasswordTitle: '重置密碼',
    questionnaireTitle: '入職信息填寫',
    loginError: '用戶名或密碼錯誤',
    questionnaireFinished: '已完成入職信息',
    questionnaireFinishedText1: '恭喜你已完成了全部問題',
    toHomeBtn: '首頁',
    email: '郵箱',
    alertTitle: '注意',
    btn: {
      forgetPassword: '忘記密碼',
      reset: '重置'
    },
    message: {
      resetEmailSuccess: '重置密碼郵件發送成功，請注意查收',
      wrongEmail: '無法重置密碼，請檢查填寫的郵箱地址'
    }
  },
  nestle: {
    error: {
      fileNotUpload: '請上傳附件',
      fileSizeError: '文件大小不能超過4MB',
      passwordTip: '密碼必須包含大小寫字母和數字，長度至少10位，特殊符號只能是_#@.-',
      passwordNotSame: '兩次輸入的密碼不一致',
      isRequired: '該字段不能為空',
      noSteps: '未獲取到文書工作具體步驟，請刷新後重試',
      serverError: '服務器內部錯誤',
      uploadError: '上傳文件失敗，請重試',
      uploadSuccess: '上傳文件成功',
      phoneError: '電話格式不正確',
      birthIsNeeded: '需要提供出生日期。',
      ageTooSmall: '您已經指出您的年齡不足16歲。您必須至少16歲，這樣才能為我們公司工作。',
      nameNotEn: '請檢查並確保您是以拼音或英文作輸入方可進入下一頁',
      nationalIDIssueDateIsNeeded: '要求提供國民身份證簽發日期',
      nationalIDExpireDateIsNeeded: '要求提供國民身份證到期日期',
      nationalIDExpireLargeThanIssue: '國民身份證簽發日期應當早於到期日期。',
      nationalIDExpireLargeThanNow: '國民身份證到期日期應該是將來的某個日期。',
      nationalIDRegex: '請輸入有效的{nationID}。使用格式{format}',
      mustSelected: '該選項必須勾選',
      tryAgain: '請重試'
    },
    upload: '上載',
    fileChangedButNoUpload: '文件已修改但未上傳，確定離開？',
    year: '{year} 年',
    confirm: '確認',
    language: '語言',
    completeMyPaperwork: '完成我的文書工作',
    learning: '學習',
    myFirstDay: '我的第一天',
    createPassword: '創建你的密碼',
    userName: '用戶名',
    firstName: '名',
    lastName: '姓',
    password: '密碼',
    reEnterPassword: '再次輸入密碼',
    agreeStatement: '我已經閱讀並接受隱私內容協議',
    statementTitle: '隱私內容協議',
    statementBody: `
    <div style="font-size: medium;">
    以下聲明會在您登入職準備首頁前，在歡迎信連結中顯示。
    <br><br>
    <div style="text-align: center;font-size: large;">聲明</div>
    <br><br>
    本人特此簽字確認：
    <br><br>
    - 登入全球入職門戶網站，我可能會接觸到雀巢S.A.、其子公司或附屬公司專有的保密資訊，從此資訊被確定為保密資訊之日起，由雀巢、其繼承人或代理人（總稱“雀巢”）管控，或由他們共同管控。此類保密資訊可能涉及不為社會大眾所知的雀巢業務、運營、員工、財務、專有產品和流程、方法、專有知識、製造工藝、系統改進、研發專案、技術、技術和商業資料、圖紙、規範、業務計畫以及雀巢業務相關的其它資訊。
    <br><br>
    - 本人保證對此類資訊進行保密，未事先獲得雀巢書面許可，不會把此類資訊直接或間接地揭露給協力廠商，或用於準備雀巢未來僱傭外的其他用途。
    <br><br>
    - 本保密協議應當從我接受當前的聲明之時起，到我在雀巢的僱傭開始日期止，在雀巢任職期間以及與雀巢的僱傭關係終止後，只要雀巢沒有把相關的保密資訊整體對社會公眾披露，我都會對此類資訊進行保密。
    <br><br>
    - 未經許可擅自揭露保密資訊，會給雀巢帶來損害，本人可能會因此被提起法律訴訟，且不排除雀巢針對此等違約而在所有適用法律項下可以享有其它任何權利和賠償。
    </div>
    `,
    toEmployeePortal: '去員工中心',
    createPasswordTitle: '創建你的密碼',
    paperworkTitle: '入職信息填寫',
    back: '返回',
    cancel: '取消',
    next: '下一步',
    finish: '完成',
    submit: '提交',
    newHirePaperwork: '新入職文書',
    paperworkStepZeroText1: '請按照以下流程填寫信息。',
    paperworkStepZeroText2: '使用流程下方的按鈕進行導航。',
    paperworkStepZeroText3: '點擊取消鍵可以以後再進入文書頁面填寫信息，之前填寫的信息會被保存。',
    followUs: '在<a href="http://www.nestle.com/change-country">社群媒體</a>上瞭解我們吧。瀏覽主頁，選擇您的國家，找到您的國家的特定頻道。',
    donnotBeShared: '本入職網站中的內容只供您作為新員工時使用。基於版權原因，網站內容不得在雀巢外部分享。',
    learningPage: {
      learning: '學習',
      introduction: '本學習部分為您提供所需的相關資訊，以妥善開始您在雀巢內部的旅程。',
      ourHistory: '我們的歷史',
      ourHistoryDescription: '......由公司兩名前輩講述我們第一家工廠的確實(確切)地點！',
      ourPurpose: '我們的宗旨和價值觀',
      ourPurposeDescription: '......是我們行事的基礎，帶領我們取得長期成功。',
      ourEnvironment: '我們的工作環境',
      ourEnvironmentDescription: '......您在雀巢工作可以寄予的期望。',
      messageFromMaurizioPatarnello: '來自Maurizio Patarnello的歡迎致辭',
      nestleWaters: '雀巢飲用水',
      cerealPartnersWorldwide: '進一步瞭解全球穀物聯盟',
      messageFromJoeSivewright: '來自Joe Sivewright的歡迎致詞',
      purinaHistory: '普瑞納-歷史',
      messageFromGregBehar: '來自Greg Behar的歡迎致詞',
      nestleHealthScience: '進一步了解雀巢健康科學',
      nestleNespresso: '雀巢奈斯派索'
    },
    landingPage: {
      title: '恭喜您！',
      subtitle: '很高興您加入我們的團隊。',
      introduction: '入職準備平臺是您工作第一天之前，把我們作為一個待加入企業開始加以瞭解的地方。',
      subIntroduction: '開始您的入職之旅，準備享受您的工作第一天吧！',
      welcome: '歡迎來到雀巢',
      welcomeDescription: '敬請觀看來自以下角色的歡迎致辭：',
      ourCEO: '公司執行總裁Mark Schneider',
      paperwork: '完成我的文書工作',
      paperworkDescription: '為了妥善管理您的入職事宜，請在今後的三天內完成本部分。',
      myFirstDay: '我的工作第一天',
      myFirstDayDescription: '在這裡找到更多關於您的工作場所的資訊。',
      learning: '學習',
      learningDescription: '開始熟悉我們公司的文化和價值觀。',
      welcomeTitle: '歡迎！',
      welcomeBody: `
      <div style="font-size: medium;">
      我們的入職前準備平台將為您提供公司的概述，並幫助您了解在第一個工作日之前需要遵循的程序和要求。
      <br/>
      首先，請至完成我的個人資料選項。
      <br/>
      我們希望這個平台能夠幫助您在雀巢獲得極佳的啟程!
      </div>`,
      welcomeDontShow: '不再顯示',
      welcomeCompletePaperwork: '完成我的文書工作'
    },
    myFirstDayPage: {
      title: '我的第一天',
      introduction: '這個入職準備平台是您工作第一天之前，把我們作為一個待加入企業開始加以了解的地方。開始您的入職之旅程，準備享受您第一天的工作吧！',
      gcr: '雀巢大中華區',
      china: '雀巢中國',
      hk: '雀巢香港',
      tw: '雀巢台灣',
      information: '您需要知道的資訊'
    },
    myFirstDayPageCN: {
      title: 'My First Day',
      china: 'Nestlé Mainland China, GCR',
      information: 'Information you need to know',
      chinaWebSite: 'Nestlé China Website',
      gcrOffice: 'Nestlé GCR Head Office',
      linkedIn: 'Nestlé LinkedIn',
      cnWechatQR1: 'Nestlé CN Official Account',
      cnWechatQR2: 'Nestlé Recruitment Official Account'
    },
    myFirstDayPageTW: {
      title: '我的第一天',
      tw: '雀巢台灣',
      information: '您需要知道的資訊',
      twWebSite: '造訪官網',
      twOffice: '雀巢辦公室',
      story: '品牌大事記',
      twYoutube: '雀巢台灣YouTube',
      twFacebook: '雀巢台灣臉書專頁'
    },
    myFirstDayPageHK: {
      title: '我的第一天',
      hk: '雀巢香港',
      information: '您需要知道的資訊',
      hkWebSite: '造訪官網',
      hkOffice: '雀巢辦公室',
      story: '品牌大事記'
    },
    paperworkHome: {
      title: '完成我的文書工作',
      introduction: '在本頁中，您將找到在您工作第一天之前需要完成的所有重要的文書工作。',
      firstSubIntroduction: '我們公司致力於綠色技術並保護我們的環境。為此，法律允許時，新員工文書工作可以在這個安全的線上平臺上完成。',
      secondSubIntroduction: '您正在提供的個人資訊將會用來準備您入職雀巢的文書工作，構成您的員工生活的一部分。',
      step: '步驟',
      firstStepTitle: '輸入您的資訊',
      firstStepIntroduction1: '系統僅會要求您通過一系列頁面，一次性輸入您對的資訊。',
      firstStepIntroduction2: '有些資訊是可選的，有些資訊是必填的。如果您錯過了某個必填欄位，門戶將會將其突出顯示。',
      firstStepIntroduction3: '在每個頁面的底部，您將看到以下按鈕-<b>下一步、返回和關閉</b>。您可點擊“<b>關閉</b>”來保存您所輸入的資訊，並在稍後繼續。',
      secondStepTitle: '簽署您的文件檔案',
      secondStepIntroduction1: '一旦您完成您的文書工作，系統可能會要求您線上簽字（如果您所在的國家能夠實現）。如果要求提供這種電子簽名，選擇“<b>點擊簽字</b>”按鈕，您的表單會自動簽名。',
      thirdStepTitle: '開始小提示',
      thirdStepIntroduction1: '確保已關閉所有彈出視窗攔以免阻礙程序。並確保您的電腦上已安裝了Internet Explorer 9或更高版本及Adobe Reader 4.0或更高版本。',
      thirdStepIntroduction2: '如果您準備開始，只需點擊“<b>完成我的入職文書工作</b>”！',
      contact: '您可以與我聯絡\u3000',
      start: '現在開始並完成您的入職文書工作',
      finished: '您的入職文書工作已經完成'
    },
    nespresso: {
      title: 'Nespresso',
      introduction: '歡迎來到奈斯派索',
      sectionTitle1: 'Jean-Marc Duvoisin, CEO Nestle Nespresso',
      sectionTitle2: 'Learn more about Nespresso History',
      sectionTitle3: 'Nespresso Brand',
      sectionTitle4: 'Learn more about Nespresso Purpose & Values',
      sectionTitle5: 'Nespresso Priorities & Road Map'
    }
  }
}
